
import { GoogleGenAI, Type } from "@google/genai";
import { Identity, GenerationConfig } from "../types";

export const generateIdentityWithAI = async (config: GenerationConfig): Promise<Identity> => {
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
  
  const schema = {
    type: Type.OBJECT,
    properties: {
      name: { type: Type.STRING },
      gender: { type: Type.STRING },
      birthday: { type: Type.STRING },
      age: { type: Type.NUMBER },
      idNumber: { type: Type.STRING },
      address: {
        type: Type.OBJECT,
        properties: {
          street: { type: Type.STRING },
          city: { type: Type.STRING },
          state: { type: Type.STRING },
          zipCode: { type: Type.STRING },
          country: { type: Type.STRING },
        },
        required: ['street', 'city', 'state', 'zipCode', 'country']
      },
      phone: { type: Type.STRING },
      email: { type: Type.STRING },
      job: { type: Type.STRING },
      company: { type: Type.STRING },
      creditCard: {
        type: Type.OBJECT,
        properties: {
          number: { type: Type.STRING },
          expiry: { type: Type.STRING },
          cvv: { type: Type.STRING },
          type: { type: Type.STRING },
        },
        required: ['number', 'expiry', 'cvv', 'type']
      },
      bio: { type: Type.STRING },
    },
    required: ['name', 'gender', 'birthday', 'age', 'idNumber', 'address', 'phone', 'email', 'job', 'company', 'creditCard', 'bio']
  };

  const prompt = `生成一个真实的虚拟身份档案。
  国家: ${config.country}
  要求: 性别为 ${config.gender || '随机'}, 年龄范围 ${config.minAge}-${config.maxAge}。
  必须输出纯 JSON，内容要极其真实且符合当地文化习惯。`;

  try {
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: [{ parts: [{ text: prompt }] }],
      config: {
        responseMimeType: "application/json",
        responseSchema: schema,
        temperature: 0.8,
        thinkingConfig: { thinkingBudget: 0 }
      }
    });

    const data = JSON.parse(response.text || "{}");
    return {
      ...data,
      id: Math.random().toString(36).substring(2, 11),
      timestamp: Date.now()
    };
  } catch (error) {
    console.error("Gemini AI 生成失败:", error);
    throw error;
  }
};
